import {Fragment, useState, useEffect} from 'react'
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { ReconcilationColumns } from './elemant/Columns'
import ReconslationTableView from './ReconslationTableView';
import { ReconslationTableEdit } from './ReconslationTableEdit';

export const ReconcilationTable = ({
    data,
    setData,
    page_no,
    disabledState,
    setDisabledState
}) => {

    const [editRow, setEditRow] = useState(null);
    const [editRowBakup, setEditRowBakup] = useState({});

    const getCellStyles = (column) => {
        return {
            width: column.width,
            backgroundColor: column.backgroundColor,
            color: column.color,
            fontSize: column.fontSize,
            padding: column.padding,
            textAlign: column.textAlign,
        };
    };
    
    return (
        <TableContainer sx={{ maxHeight: "53.1vh" }}>
            <Table stickyHeader aria-label="sticky table">
                <TableHead>
                    <TableRow>
                        {ReconcilationColumns.map((column) => (
                            <TableCell
                                key={column.id}
                                align="left"
                                style={getCellStyles(column)}
                            >
                                {column.label}
                            </TableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                {data && data.map((row, index) => {
    return (
        <Fragment key={row.sr_no}>
            {row.page_no === page_no && (
                <>
                    {editRow !== row.sr_no ? (
                        <ReconslationTableView 
                            row={row}
                            setData={setData}
                            setEditState={setEditRow}
                            setEditRowBakup={setEditRowBakup}
                            index={index}
                            disabledState={disabledState}
                            setDisabledState={setDisabledState}
                        />
                    ) : (
                        <ReconslationTableEdit 
                            row={row}
                            data={data}
                            setData={setData}
                            setEditState={setEditRow}
                            editRowBakup={editRowBakup}
                            index={index}
                            setDisabledState={setDisabledState}
                        />
                    )}
                </>
            )}
        </Fragment>
    );
})}
                </TableBody>
            </Table>
        </TableContainer>
    )
}